import React, { useState, useEffect } from "react";
import Inertia from "@inertiajs/inertia";
import { Link, usePage } from "@inertiajs/inertia-react";
import ListItem from "./ListItem";
import axios from "axios";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { LeftArrow, RightArrow } from "../Shared/Arrows";
import { useViewport, onWheel } from "../Shared/Helpers";
import { BiChevronsDown } from "react-icons/bi";

export default function ListView({
  header,
  description,
  items,
  maxResults,
  playlistId,
  nextPageToken,
  skipFirstItem,
  seeAllLink,
  hideSeeAll,
  desktopVertical,
  showPartNumber,
  maxItems,
  isChannelList,
  showDiffDate,
}) {
  const { isLoggedIn, imgixURL } = usePage().props;
  const { props } = usePage();
  const [pageToken, setPageToken] = useState(nextPageToken);
  const [videos, setVideos] = useState(items);
  const [currentPage, setCurrentPage] = useState(1);
  const { width } = useViewport();

  useEffect(function () {
     setVideos(items);
     setPageToken(nextPageToken);
  }, [items, nextPageToken]);

  {
    /* use horizontal ScrollMenu only 768px and above, otherwise show vertical list */
  }
  {
    /* desktopVertical - always show vertical list in desktop mode - used for watch tabs */
  }
  const isHorizontalScroll = !desktopVertical && width >= 768;

  const loadMore = () => {
    // load more only if there's next page token
    if (pageToken === null) {
    return;
    }

    axios
      .get(`/on-demand/api/playlist/${playlistId}?page=${currentPage + 1}`)
      .then(({ data }) => {
        setCurrentPage(data.current_page);
        setPageToken(data.next_page_url);
        setVideos([...videos, ...data.data]);
      });
  };

  let TheLoop =
    videos &&
    videos.map((item, index, array) => {
      let itemIsLocked = true;
      if (maxItems && index > maxItems) {
        return null;
      }
      let displayItem = item;
      if (skipFirstItem && index === 0) {
        return null;
      } else {
        itemIsLocked =
          !isLoggedIn &&
          displayItem.pivot &&
          !displayItem.pivot.is_latest_video;
      }

      return isChannelList ? ( // for channel listing
        <ListItem
          imageUrl={`https://${imgixURL}/${displayItem.largeThumbnail}`}
          title={displayItem.title}
          isHorizontalScroll={isHorizontalScroll}
          description={displayItem.shortDescription}
          itemId={index}
          link={
            displayItem.slug == "joseph-prince-ministries"
              ? "/on-demand/latest"
              : "/on-demand/channel/" + displayItem.slug
          }
          key={index}
        />
      ) : (
        // for all youtube videos
        <ListItem
          imageUrl={displayItem.thumbnail_url}
          title={displayItem.title}
          date={
            showDiffDate
              ? displayItem.youtube_published_at_diff
              : displayItem.youtube_published_at
          }
          // videoId={displayItem.videoId}
          sermonId={displayItem.episode_identifier ?? null}
          isHorizontalScroll={isHorizontalScroll}
          partNumber={showPartNumber ? displayItem.part_number : null}
          itemIsLocked={displayItem.is_locked != null ? displayItem.is_locked : itemIsLocked}
          link={"/on-demand/watch/" + displayItem.slug}
          itemId={index}
          key={index}
        />
      );
    });

  return (
    <>
      {header && header != "" && (
        <div className="row">
          <div className={!hideSeeAll ? `col-8` : `col-12`}>
            <h2 className="text-xl font-bold">{header}</h2>
          </div>
          {!hideSeeAll && (
            <div className="col-4 text-right text-base font-medium flex justify-end items-center pt-px">
              <Link href={seeAllLink} className="text-primary">
                See all
              </Link>
            </div>
          )}
        </div>
      )}

      {description && description != "" && (
        <div className="row mt-1 mb-5">
          <div className="col">
            <p className={"text-sm text-left text-neutral-content"}>
              {description}
            </p>
          </div>
        </div>
      )}
      {isHorizontalScroll ? (
        <>
          <ScrollMenu
            LeftArrow={LeftArrow}
            RightArrow={
              <RightArrow
                pushNewItems={loadMore}
                numOfItems={videos ? videos.length : 0}
              />
            }
            onWheel={onWheel}
          >
            {TheLoop}
          </ScrollMenu>
          <div className={`col-12 pt-4 pb-4`}>
            <div className="w-full border-b border-solid border-[#7D7D7D]"></div>
          </div>
        </>
      ) : (
        // <div className={horizontal ?
        //     "row flex-nowrap overflow-x-auto mt-3 mb-4" :
        //     "row mt-3 mb-4"}>
        <div className="row mt-3 mb-4">
          {TheLoop}
          {pageToken && (
            <button
              className="flex justify-center items-center text-sm"
              onClick={loadMore}
            >
              <BiChevronsDown /> Load More
            </button>
          )}
          <div className={`col-12 pt-4 `}>
            <div className="w-full border-b border-solid border-[#7D7D7D]"></div>
          </div>
        </div>
      )}
    </>
  );
}
